import {
  Box,
  Container,
  Typography,
  // IconButton,
  Divider,
  Button,
} from '@mui/material';
import Grid from '@mui/material/Grid';
// import GitHubIcon from '@mui/icons-material/GitHub';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import InstagramIcon from '@mui/icons-material/Instagram';
import { motion } from 'framer-motion';
import BrandLogo from './BrandLogo';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

const services = [
  'Landing Pages',
  'E-Commerce Sites',
  'Booking Systems',
  'Business Dashboards',
  'SEO-Optimized Sites',
];

// const socials = [
//   {
//     icon: <GitHubIcon />,
//     href: 'https://github.com',
//     label: 'GitHub',
//     color: '#fff',
//   },
//   {
//     icon: <LinkedInIcon />,
//     href: 'https://linkedin.com',
//     label: 'LinkedIn',
//     color: '#0A66C2',
//   },
//   {
//     icon: <TwitterIcon />,
//     href: 'https://twitter.com',
//     label: 'Twitter',
//     color: '#1DA1F2',
//   },
//   {
//     icon: <InstagramIcon />,
//     href: 'https://instagram.com',
//     label: 'Instagram',
//     color: '#E1306C',
//   },
// ];

export default function Footer() {
  const handleNavClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box
      component='footer'
      sx={{
        background: 'linear-gradient(180deg, #0F0F1A 0%, #08080F 100%)',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        pt: { xs: 6, md: 8 },
        pb: 4,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background accents */}
      <Box
        sx={{
          position: 'absolute',
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: '#7C3AED',
          filter: 'blur(180px)',
          opacity: 0.04,
          top: '-20%',
          left: '50%',
          transform: 'translateX(-50%)',
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth='lg'>
        <Grid container spacing={4}>
          {/* Brand col */}
          <Grid size={{ xs: 12, md: 4 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Logo */}
              <BrandLogo iconSize={38} sx={{ mb: 2 }} />

              <Typography
                variant='body2'
                sx={{
                  color: 'rgba(255,255,255,0.5)',
                  lineHeight: 1.8,
                  mb: 3,
                  maxWidth: 280,
                }}
              >
                Crafting premium digital experiences for ambitious small
                businesses. Let&apos;s build something remarkable together.
              </Typography>

              {/* Social icons */}
              {/* <Box sx={{ display: 'flex', gap: 1 }}>
                {socials.map((social) => (
                  <IconButton
                    key={social.label}
                    component="a"
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    sx={{
                      width: 40,
                      height: 40,
                      background: 'rgba(255,255,255,0.06)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      color: 'rgba(255,255,255,0.6)',
                      borderRadius: '10px',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: `${social.color}20`,
                        borderColor: `${social.color}60`,
                        color: social.color,
                        transform: 'translateY(-3px)',
                      },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Box> */}
            </motion.div>
          </Grid>

          {/* Nav links */}
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <Typography
                variant='overline'
                sx={{
                  color: '#A78BFA',
                  fontWeight: 700,
                  letterSpacing: 1.5,
                  display: 'block',
                  mb: 2,
                }}
              >
                Navigation
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                {navLinks.map((link) => (
                  <Button
                    key={link.label}
                    onClick={() => handleNavClick(link.href)}
                    sx={{
                      justifyContent: 'flex-start',
                      p: 0,
                      color: 'rgba(255,255,255,0.5)',
                      fontSize: '0.875rem',
                      fontWeight: 400,
                      minWidth: 0,
                      '&:hover': { color: '#fff', background: 'none' },
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            </motion.div>
          </Grid>

          {/* Services links */}
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Typography
                variant='overline'
                sx={{
                  color: '#FCD34D',
                  fontWeight: 700,
                  letterSpacing: 1.5,
                  display: 'block',
                  mb: 2,
                }}
              >
                Services
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                {services.map((service) => (
                  <Button
                    key={service}
                    onClick={() => handleNavClick('#services')}
                    sx={{
                      justifyContent: 'flex-start',
                      p: 0,
                      color: 'rgba(255,255,255,0.5)',
                      fontSize: '0.875rem',
                      fontWeight: 400,
                      minWidth: 0,
                      '&:hover': { color: '#fff', background: 'none' },
                    }}
                  >
                    {service}
                  </Button>
                ))}
              </Box>
            </motion.div>
          </Grid>

          {/* CTA col */}
          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <Typography
                variant='overline'
                sx={{
                  color: '#22D3EE',
                  fontWeight: 700,
                  letterSpacing: 1.5,
                  display: 'block',
                  mb: 2,
                }}
              >
                Ready to Start?
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  color: 'rgba(255,255,255,0.5)',
                  lineHeight: 1.7,
                  mb: 2.5,
                }}
              >
                Have a project in mind? Let&apos;s discuss how I can help bring
                your vision to life.
              </Typography>
              <Button
                onClick={() => handleNavClick('#contact')}
                sx={{
                  background: 'linear-gradient(135deg, #F59E0B, #D97706)',
                  color: '#000',
                  fontWeight: 700,
                  px: 3,
                  py: 1.25,
                  borderRadius: '10px',
                  fontSize: '0.875rem',
                  boxShadow: '0 4px 15px rgba(245,158,11,0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #FBBF24, #F59E0B)',
                    boxShadow: '0 6px 20px rgba(245,158,11,0.45)',
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                Start a Project
              </Button>
            </motion.div>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.06)' }} />

        {/* Bottom bar */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography
            variant='body2'
            sx={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.82rem' }}
          >
            © {new Date().getFullYear()} Get Your Site Today. All rights
            reserved.
          </Typography>
          {/* <Box sx={{ display: 'flex', gap: 3 }}>
            {['Privacy Policy', 'Terms of Service'].map((link) => (
              <Typography
                key={link}
                variant='body2'
                sx={{
                  color: 'rgba(255,255,255,0.35)',
                  fontSize: '0.82rem',
                  cursor: 'pointer',
                  '&:hover': { color: 'rgba(255,255,255,0.7)' },
                }}
              >
                {link}
              </Typography>
            ))}
          </Box> */}
        </Box>
      </Container>
    </Box>
  );
}
